import React from "react";
import { Card } from "react-bootstrap";

const SeoHeroBlock = ({ hero, topLinks }) => {

    if (!hero) return null;

    return (
        <Card className="shadow-sm rounded small p-3">

            <h1 className="mb-2 text-center text-md-start text-muted fs-4">
                {hero.h1}
            </h1>

            {topLinks}

            {hero.p1 && <p className="text-muted mb-1">{hero.p1}</p>}
            {hero.p2 && <p className="text-muted mb-1">{hero.p2}</p>}

            {hero.bullets && (
                <ul className="list-unstyled text-muted mb-2 ps-3">
                    {hero.bullets.map((b, i) => (
                        <li key={i}>• {b}</li>
                    ))}
                </ul>
            )}

            {hero.p3 && <p className="text-muted mb-0">{hero.p3}</p>}

        </Card>
    );
};

export default SeoHeroBlock;